<!-- =========================================================================================
    File Name: ResetPassword.vue
    Description: Reset Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template> 
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card id="reset-password-loading" class="vs-con-loading__container">
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div
              class="
                vx-col
                hidden
                sm:hidden
                md:hidden
                lg:block
                lg:w-1/2
                mx-auto
                self-center
              "
            >
              <img
                src="@/assets/images/pages/reset-password.png"
                alt="login"
                class="mx-auto"
              />
            </div>

            <div
              class="
                vx-col
                sm:w-full
                md:w-full
                lg:w-1/2
                mx-auto
                self-center
                d-theme-dark-bg
              "
            >
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">Reset Password</h4>
                  <p>Please enter your new password.</p>
                </div>
                <vs-alert :active="alert" color="success" icon="new_releases">
                  <span>Password updated.</span>
                </vs-alert>
                <vs-row>
                  <vs-col vs-w="12" class="mt-2">
                    <vs-input
                      type="email"
                      label-placeholder="Email"
                      v-model="email"
                      class="w-full"
                      name="email"
                      v-validate="'required|email'"
                    />
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('email')"
                    >
                      {{ errors.first('email') }}
                    </span>
                  </vs-col>
                  <vs-col vs-w="12" class="mt-2">
                    <vs-input
                      type="password"
                      label-placeholder="Password"
                      v-model="password"
                      class="w-full"
                      name="password"
                      v-validate="'required'"
                    />
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('password')"
                    >
                      {{ errors.first('password') }}
                    </span>
                  </vs-col>
                  <vs-col vs-w="12" class="mt-2">
                    <vs-input
                      type="password"
                      label-placeholder="Confirm Password"
                      v-model="passwordConfirmation"
                      class="w-full"
                      name="password confirmation"
                      v-validate="'required'"
                    />
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('password confirmation')"
                    >
                      {{ errors.first('password confirmation') }}
                    </span>
                  </vs-col>
                  <vs-col vs-w="12" class="mt-6">
                    <div
                      class="
                        flex flex-wrap
                        justify-between
                        flex-col-reverse
                        sm:flex-row
                      "
                    >
                      <vs-button
                        type="border"
                        to="/login"
                        class="w-full sm:w-auto mb-8 sm:mb-auto mt-3 sm:mt-auto"
                        >Go Back To Login</vs-button
                      >
                      <vs-button
                        class="w-full sm:w-auto"
                        @click="submit"
                        :disabled="disabledSubmit"
                        >Reset</vs-button
                      >
                    </div>
                  </vs-col>
                </vs-row>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import user from '@/http/requests/user'
export default {
  computed: {
    token() {
      return this.$route.params.token
    },
    disabledSubmit() {
      return (
        this.errors.any() ||
        this.email === '' ||
        this.password === '' ||
        this.passwordConfirmation === ''
      )
    },
  },

  data() {
    return {
      alert: false,
      email: '',
      password: '',
      passwordConfirmation: '',
    }
  },

  methods: {
    submit() {
      this.openLoading()
      user
        .resetPassword({
          token: this.token,
          email: this.email,
          password: this.password,
          passwordConfirmation: this.passwordConfirmation,
        })
        .then( res => {
          this.alert = true
          this.closeLoading()
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Password Updated'
          })

          this.$router.push({
            path: '/login'
          })

        })
        .catch( res => {
          this.showValidationErrors(res)
          this.closeLoading()
        })
    },
    openLoading() {
      this.$vs.loading({
        container: '#reset-password-loading',
        scale: 0.45
      })
    },
    closeLoading() {
      this.$vs.loading.close('#reset-password-loading > .con-vs-loading')
    }
  },
}
</script>
